import { render, staticRenderFns } from "./SubmissionFormComment.vue?vue&type=template&id=1a897994&scoped=true&"
import script from "./SubmissionFormComment.vue?vue&type=script&lang=ts&"
export * from "./SubmissionFormComment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a897994",
  null
  
)

export default component.exports